import intl from "react-intl-universal";

const supplierValues = {
  COMPRA_DE_INSUMOS: 1,
  TRANSFERENCIA: 2,
  COMPRA_ATG: 3,
  CONSIGNEE_STOCK: 4,
};

const supplierOrigin = {
  [supplierValues.COMPRA_DE_INSUMOS]: "commons.supplierOrigin.inputPurchase",
  [supplierValues.TRANSFERENCIA]: "commons.supplierOrigin.transfer",
  [supplierValues.COMPRA_ATG]: "commons.supplierOrigin.atgPurchase",
  [supplierValues.CONSIGNEE_STOCK]: "commons.supplierOrigin.consigneeStock",
  IsPurchase: (origin) => origin === supplierValues.COMPRA_DE_INSUMOS,
  IsTransfer: (origin) => origin === supplierValues.TRANSFERENCIA,
  IsAtgPurchase: (origin) => origin === supplierValues.COMPRA_ATG,
  IsConsigneeStock: (origin) => origin === supplierValues.CONSIGNEE_STOCK,
  getName: function (origin) {
    return intl.get(this[origin]);
  },
};

export { supplierOrigin, supplierValues };
